import { isValidCharactersXSS, isValidEmail } from "@Utils/Functions";
import { phoneStartWithIndicative } from "@Utils/phones";
import { CountryCode, isValidPhoneNumber } from "libphonenumber-js";

export const isFormFilled = (formData, selectedCountryCode) => {
	if (
		formData?.name !== "" &&
        isValidCharactersXSS(formData?.phone) && 
		formData?.email !== "" &&
        isValidEmail(formData?.email) &&
		formData?.phone !== "" &&
		isValidPhoneNumber(formData?.phone, selectedCountryCode?.code) &&
		!phoneStartWithIndicative(selectedCountryCode?.value, formData?.phone) &&

		formData?.fincatyc
	)
		return true;
	else return false;
};

export 	const handleFormBlur = (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
    fieldName: string,
    {
        formData,
        selectedCountryCode,
        errors,
        setErrors,
    }: {
        formData: {
            name: string;
            phone: string;
            email: string;
        };
        selectedCountryCode: {
            code: CountryCode;
            value: string;
        };
        errors: {
            name: boolean;
            phone: boolean;
            email: boolean;
        };
        setErrors: (value: React.SetStateAction<{ name: boolean; phone: boolean; email: boolean }>) => void;
    }
) => {
    const value = e.target.value;
    if (fieldName === "name") {
        const isValid = value.trim() !== "" && isValidCharactersXSS(value);
        setErrors({ ...errors, name: !isValid });
    } else if (fieldName === "phone") {
        setErrors({
            ...errors,
            phone:
                !isValidPhoneNumber(String(value), selectedCountryCode?.code) ||
                phoneStartWithIndicative(selectedCountryCode?.value, formData?.phone),
        });
    } else if (fieldName === "email") {
        const isValid = value.trim() !== "" && isValidEmail(value);
        setErrors({ ...errors, email: !isValid });
    }
};